export const BUDGETS_MODULE_VIEWS = {
    NEW_BUDGET: "NEW_BUDGET",
    EDIT_BUDGET: "EDIT_BUDGET",
};